<template>
  <transition name="fade_">
    <div
      class="rooming-form"
      v-if="show"
    >
      <form
        class="pax-form"
        @submit.prevent="submit"
      >
        <div class="row">
          <div class="pax-form-group col-4">
            <label for="_ident">Dni/Pasaporte</label>
            <div class="pax-form-input">
              <input
                autocomplete="off"
                type="text"
                class="pax-form-input"
                id="_ident"
                maxlength="50"
                v-model="model.ident"
              >
            </div>
          </div>
          <div class="pax-form-group col-4">
            <label for="_surname">Apellido</label>
            <div class="pax-form-input">
              <input
                autocomplete="off"
                type="text"
                class="pax-form-input"
                id="_surname"
                v-model="model.surname"
              >
            </div>
          </div>
          <div class="pax-form-group col-4">
            <label for="_name">Nombre</label>
            <div class="pax-form-input">
              <input
                autocomplete="off"
                type="text"
                class="pax-form-input"
                id="_name"
                v-model="model.name"
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="pax-form-group col-4">
            <label for="_birthday">Fecha de nacimiento</label>
            <div class="pax-form-input">
              <cleave
                :options="{ date: true, datePattern: ['d', 'm', 'Y'] }"
                v-model="model.birthday"
                :raw="false"
              />
            </div>
          </div>
          <div class="pax-form-group col-4">
            <label>Sexo</label>
            <label
              for="_gender"
              class="pax-form-select"
            >
              <span class="pax-form-select-span">{{ model.gender }}</span>
              <select
                id="_gender"
                v-model="model.gender"
              >
                <option>Femenino</option>
                <option>Masculino</option>
              </select>
            </label>
          </div>
          <div class="pax-form-group col-4">
            <label>Nacionalidad</label>
            <label
              for="_nationality"
              class="pax-form-select"
            >
              <span class="pax-form-select-span">{{ model.nationality }}</span>
              <select
                id="_nationality"
                v-model="model.nationality"
              >
                <option
                  v-for="(country, c) in COUNTRIES"
                  :value="country"
                  :key="c"
                >
                  {{ country }}
                </option>
              </select>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="pax-form-group col-4">
            <label for="_areacode">Codigo de area</label>
            <div class="pax-form-input">
              <input
                autocomplete="off"
                type="text"
                class="pax-form-input"
                id="_areacode"
                v-model="model.areacode"
                maxlength="4"
              >
            </div>
          </div>
          <div class="pax-form-group col-4">
            <label for="_tel">Teléfono</label>
            <div class="pax-form-input">
              <input
                autocomplete="off"
                type="text"
                class="pax-form-input"
                id="_tel"
                maxlength="30"
                v-model="model.tel"
              >
            </div>
          </div>
          <div class="pax-form-group col-4">
            <label>Embarque</label>
            <label
              for="_boarding"
              class="pax-form-select"
            >
              <span class="pax-form-select-span">{{ boarding.name }}</span>
              <select
                id="_boarding"
                v-model="model.boarding_id"
              >
                <option
                  v-for="(b, c) in boardings"
                  :value="b.id"
                  :key="c"
                >
                  {{ b.name }}
                </option>
              </select>
            </label>
          </div>
        </div>
        <div class="pax-form-group">
          <label>Observaciones</label>
          <div class="pax-form-input">
            <textarea
              rows="3"
              v-model="model.notes"
            />
          </div>
        </div>
        <template v-if="insurance">
          <div class="pax-form-group mt-3">
            <label>Travel Ace</label>
            <label
              for="insurance_old"
              class="pax-form-check check-box"
              v-if="insurance.old"
            >
              <input
                type="checkbox"
                id="insurance_old"
                v-model="model_insurance_old"
                name="insurance"
              >
              <span>Abono para mayores de {{ insurance.age }}</span>
            </label>
            <label
              for="insurance_outland"
              class="pax-form-check check-box"
              v-if="insurance.outland"
            >
              <input
                type="checkbox"
                id="insurance_outland"
                v-model="model_insurance_outland"
                name="insurance"
              >
              <span>Abono por viaje al exterior.</span>
            </label>
          </div>
          <div
            class="pax-form-legend"
            v-if="insurance.msg"
          >
            <span>{{ insurance.msg }}</span>
          </div>
        </template>
        <div class="pax-form-btns">
          <btn
            color="orange"
            size="sm"
            class="xs-4"
          >
            GUARDAR
          </btn>
          <btn
            color="white"
            size="sm"
            class="xs-4"
            @click.prevent="close"
          >
            CANCELAR
          </btn>
        </div>
      </form>
    </div>
  </transition>
</template>

<script>
import Btn from '@/components/Btn'
import swal from 'sweetalert2'
import dayjs from 'dayjs'
import { COUNTRIES, PASSENGER_TYPES } from '@/constans'
import { PASSENGERS } from '@/store/mutations'
import { clone, yyyymmdd_ddmmyyy } from '@/utils'

var today = new Date()

export default {
  components: {
    Btn
  },

  props: ['passenger'],

  name: 'PassengerForm',

  computed: {
    cleave_options () {
      return {
        date: true,
        datePattern: ['d', 'm', 'Y'],
        dateMax: today.toISOString().split('T')[0]
      }
    },
    boardings () {
      return this.$store.state.modify.departure.boardings
    },
    insurance () {
      return this.$store.state.booking.departure.insurance
    },
    boarding () {
      return (
        this.$store.state.modify.departure.boardings.find(
          i => i.id == this.model.boarding_id
        ) || {}
      )
    },
    model_insurance_old: {
      get () {
        return !!this.model.insurance_old
      },
      set (a) {
        this.model.insurance_old = a ? this.insurance.old : 0
      }
    },
    model_insurance_outland: {
      get () {
        return !!this.model.insurance_outland
      },
      set (a) {
        this.model.insurance_outland = a ? this.insurance.outland : 0
      }
    }
  },

  methods: {
    open () {
      this.show = true
    },
    close () {
      this.show = false
    },
    submit () {
      try {
        const model = clone(this.model)

        const borndate = model.birthday
          ? (([d, m, y]) => new Date([y, m, d]))(model.birthday.split('/'))
          : null

        if (/(infoas|minors)$/.test(model.type) && borndate) {
          const month = today.getMonth() - borndate.getMonth()
          let age = today.getFullYear() - borndate.getFullYear()

          if (today < borndate) {
            throw 'La fecha de nacimiento no es valida'
          }

          if (month < 0 || (month === 0 && today.getDate() < borndate.getDate())) {
            age = age - 1
          }

          if (this.$store.state.modify.departure.minors[model.type].age < age) {
            throw (
              'El pasajero "' +
							model.type_es +
							'" debe ser menor a ' +
							this.$store.state.modify.departure.minors[model.type].age +
							' años'
            )
          }
        }

        model.birthday = borndate ? dayjs(borndate).format('YYYY-MM-DD') : null

        if (model.name && model.surname) {
          model.alt = [model.name, model.surname].join(' ').trim()
        }

        const {
          ident,
          surname,
          name,
          gender,
          nationality,
          areacode,
          tel,
          birthday,
          boarding_id,
          notes,
          alt,
          insurance_old,
          insurance_outland
        } = model

        this.$store.commit(
          'modify/' + PASSENGERS,
          this.$store.state.modify.passengers.map(pax => {
            if (pax.tmp_id == this.passenger.tmp_id) {
              pax = Object.assign(pax, {
                ident,
                surname,
                name,
                birthday,
                gender,
                nationality,
                areacode,
                tel,
                boarding_id,
                notes,
                alt,
                insurance_old,
                insurance_outland
              })
            }

            return pax
          })
        )

        this.$store
          .dispatch('modify/BUDGETING')
          .catch(e => console.log([e]))
          .finally(this.close)
      } catch (e) {
        console.log([e])
        swal('', e + '', 'error')
      }
    }
  },

  watch: {
    passenger: {
      deep: true,
      handler (value) {
        this.model = clone(value)

        if (this.model.birthday) {
          this.model.birthday = dayjs(this.model.birthday, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
        }
      }
    }
  },

  data () {
    var model = clone(this.passenger)

    if (model.birthday) {
      model.birthday = dayjs(model.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }

    return {
      model,
      show: false,
      COUNTRIES
    }
  }
}
</script>
